import { Badge } from "@/components/ui/badge";
export { LinkPill, fmtTs, fmtDate, openBlob } from "@/pages/applications/sumsub/sumsubShared";

export const STATUS_LABEL = { complete: "Complete", processing: "Processing", in_progress: "In progress", started: "Started", error: "Error", deleted: "Deleted" };
const STATUS_TONE = {
  complete: "bg-emerald-100 text-emerald-800 border-emerald-300",
  processing: "bg-violet-50 text-violet-800 border-violet-300",
  in_progress: "bg-sky-50 text-sky-800 border-sky-300",
  started: "bg-sky-50 text-sky-800 border-sky-300",
  error: "bg-red-100 text-red-900 border-red-300",
  deleted: "bg-slate-100 text-slate-500 border-slate-300",
};
export const StatusPill = ({ status, testId }) => (
  <Badge variant="outline" className={`text-[10px] font-medium px-1.5 h-4 whitespace-nowrap ${STATUS_TONE[status] || STATUS_TONE.deleted}`} data-testid={testId}>
    {STATUS_LABEL[status] || status || "—"}
  </Badge>
);
export const KIND_LABEL = { report: "Report", bank_statement: "Bank statement", supporting_doc: "Supporting doc", json: "Data", other: "File" };
export const money = (n) => (n == null || Number.isNaN(Number(n)) ? "—" : Number(n).toLocaleString("en-AU", { style: "currency", currency: "AUD" }));
